import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import parseDate from 'utils/parsers/parseDate';

const L = logger('determineWeekday');

const determineWeekday = withOptions(({ date }) => {
  // supporting regular integers and strings this way
  const parsed = Number.isFinite(date) ? date : parseDate(date);

  // invalid dates will parse to NaN
  if (Number.isNaN(parsed)) {
    L.warn('()', 'Invalid parsed:', parsed, 'for date:', date);
    return NaN;
  }

  try {
    // NOTE: `.getDay()` is based on the local time zone where this function is being run
    // SEE: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/getDay
    return new Date(parsed).getDay();
  } catch (e) {
    L.warn('()', e);
    return NaN;
  }
});

export default determineWeekday;
